module.exports = __webpack_public_path__ + "static/success-confetti-e9f0d0230277c08cd3699e4affe3706b.png";